module.exports = __webpack_public_path__ + "static/hero-f0d3c6e6c1c1e56c39fd6cfed80d5b3c.png";